import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from "react-redux";
import { useMemo } from "react";
import { getStore } from "./store";
import { storeContext } from "./context";
const StoreProvider = ({ config: { integrator, isProduction, testingHostnameBackend }, children, }) => {
    const store = useMemo(() => getStore({ integrator, isProduction, testingHostnameBackend }), [integrator, isProduction, testingHostnameBackend]);
    return (_jsx(Provider, Object.assign({ store: store, context: storeContext }, { children: children })));
};
export default StoreProvider;
